export default import.meta.ROLLDOWN_FILE_URL_jdvYQqQTk4$W1kZY5QpHJg